import { Counter } from '../components/Counter';
import { Content } from '../components/Content';
import styled from 'styled-components';

const PointsWidget = ({
	type,
	maxPoints,
	points,
	title
}: PointsWidgetProps): JSX.Element => {
	return (
		<PointsWidgetWrapper>
			<Counter title={title} points={points} />
			{/* <ProgressBar maxPoints={maxPoints} points={points} /> */}
			<Content type={type} points={points} maxPoints={maxPoints} />
		</PointsWidgetWrapper>
	);
};

export default PointsWidget;

const PointsWidgetWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`;

interface PointsWidgetProps {
	type: string;
	maxPoints: number;
	points: number;
	title: string;
}
